import {
  SettingsLocation,
  WorkOrderPriorityCode,
  WorkOrderStatus,
} from "../../../models/lookupTypes";
import {
  VIEW,
  SELECTED_WO_statuses,
  SELECTED_WO_TECHS,
  SELECTED_WO_LOCS,
  SELECTED_WO_SALES,
  FROMDATE,
  TODATE,
  SCHEDULE_FROM_DATE,
  SCHEDULE_TO_DATE,
  DELIVERY_FROM_DATE,
  DELIVERY_TO_DATE,
  PICKUP_FROM_DATE,
  PICKUP_TO_DATE,
  FILTER_CLOCKED_HOURS,
  USER_IDENTITY,
  INCLUDE_FINALIZED,
} from "../../common/constants/filterParamConstants";

export interface Filter {
  view: number;
  woStatuses?: string[] | null;
  woTechs?: string[] | null;
  woLocations?: string[] | null;
  woSalesPersons?: string[] | null;
  woCustomers?: number[];
  customerIdentity?: number;
  userIdentity?: number;
  locations?: string;
  workOrderCreationStartDate?: Date;
  workOrderCreationEndDate?: Date;
  workOrderScheduleFromDate?: Date;
  workOrderScheduleToDate?: Date;

  workOrderDeliveryStartDate?: Date;
  workOrderDeliveryEndDate?: Date;

  workOrderPickupStartDate?: Date;
  workOrderPickupEndDate?: Date;

  searchString?: string;
  clockedHours?: boolean;
  filterClockedHours?: boolean;
  filterOverClockedHours?: boolean;
  includeFinalized?: boolean;
  [key: string]:
    | string
    | string[]
    | boolean
    | number
    | Date
    | number[]
    | undefined;
}
// export const getFilterDefState = (): Filter => ({
//   view: localStorage.getItem(`${VIEW}_${localStorage.getItem("username") || ""}`) || ""
// });

const isValidDate = (dateString: string | null) => {
  return dateString && !isNaN(Date.parse(dateString));
};

export const FilterDefState = (): Filter => {
  const storedUserIdentity = localStorage.getItem(USER_IDENTITY);
  const parsedUserIdentity = storedUserIdentity
    ? parseInt(storedUserIdentity, 10)
    : 0;

  return {
    view: localStorage.getItem(`${VIEW}_${localStorage.getItem("username")}`)
      ? parseInt(
          localStorage.getItem(`${VIEW}_${localStorage.getItem("username")}`),
          10,
        )
      : 0,

    userIdentity: parsedUserIdentity,
    woStatuses: localStorage.getItem(
      `${SELECTED_WO_statuses}_${localStorage.getItem("username")}`,
    )
      ? localStorage
          .getItem(
            `${SELECTED_WO_statuses}_${localStorage.getItem("username")}`,
          )
          .split(",")
      : ["0"],
    woTechs: localStorage.getItem(
      `${SELECTED_WO_TECHS}_${localStorage.getItem("username")}`,
    )
      ? localStorage
          .getItem(`${SELECTED_WO_TECHS}_${localStorage.getItem("username")}`)
          .split(",")
      : ["0"],
    woLocations: localStorage.getItem(
      `${SELECTED_WO_LOCS}_${localStorage.getItem("username")}`,
    )
      ? localStorage
          .getItem(`${SELECTED_WO_LOCS}_${localStorage.getItem("username")}`)
          .split(",")
      : ["0"],
    woSalesPersons: localStorage.getItem(
      `${SELECTED_WO_SALES}_${localStorage.getItem("username")}`,
    )
      ? localStorage
          .getItem(`${SELECTED_WO_SALES}_${localStorage.getItem("username")}`)
          .split(",")
      : ["0"],
    includeFinalized:
      localStorage.getItem(
        `${INCLUDE_FINALIZED}_${localStorage.getItem("username")}`,
      ) === "true",

    workOrderCreationStartDate: isValidDate(
      localStorage.getItem(`${FROMDATE}_${localStorage.getItem("username")}`),
    )
      ? new Date(
          localStorage.getItem(
            `${FROMDATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,
    workOrderCreationEndDate: isValidDate(
      localStorage.getItem(`${TODATE}_${localStorage.getItem("username")}`),
    )
      ? new Date(
          localStorage.getItem(
            `${TODATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,

    workOrderScheduleFromDate: isValidDate(
      localStorage.getItem(
        `${SCHEDULE_FROM_DATE}_${localStorage.getItem("username")}`,
      ),
    )
      ? new Date(
          localStorage.getItem(
            `${SCHEDULE_FROM_DATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,
    workOrderScheduleToDate: isValidDate(
      localStorage.getItem(
        `${SCHEDULE_TO_DATE}_${localStorage.getItem("username")}`,
      ),
    )
      ? new Date(
          localStorage.getItem(
            `${SCHEDULE_TO_DATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,

    workOrderDeliveryStartDate: isValidDate(
      localStorage.getItem(
        `${DELIVERY_FROM_DATE}_${localStorage.getItem("username")}`,
      ),
    )
      ? new Date(
          localStorage.getItem(
            `${DELIVERY_FROM_DATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,

    workOrderDeliveryEndDate: isValidDate(
      localStorage.getItem(
        `${DELIVERY_TO_DATE}_${localStorage.getItem("username")}`,
      ),
    )
      ? new Date(
          localStorage.getItem(
            `${DELIVERY_TO_DATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,

    workOrderPickupStartDate: isValidDate(
      localStorage.getItem(
        `${PICKUP_FROM_DATE}_${localStorage.getItem("username")}`,
      ),
    )
      ? new Date(
          localStorage.getItem(
            `${PICKUP_FROM_DATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,

    workOrderPickupEndDate: isValidDate(
      localStorage.getItem(
        `${PICKUP_TO_DATE}_${localStorage.getItem("username")}`,
      ),
    )
      ? new Date(
          localStorage.getItem(
            `${PICKUP_TO_DATE}_${localStorage.getItem("username")}`,
          ) as string,
        )
      : null,
    clockedHours: localStorage.getItem(
      `${FILTER_CLOCKED_HOURS}_${localStorage.getItem("username")}`,
    )
      ? localStorage.getItem(
          `${FILTER_CLOCKED_HOURS}_${localStorage.getItem("username")}`,
        ) === "true"
      : false,

    customerIdentity: undefined,
    genericSearchString: undefined,
  };
};

export interface WorkOrderArchive {
  documentNumber: string;
  invoiceDocumentIdentity: number;
  modifiedBy: string; //modified by and archived by will be same
  modifiedDate: string;
  rowVersion?: string;
}
export interface WorkOrder {
  woStatusIdentity: number;
  woUnitBaseSerial: string;
  createdDate: Date;
  createdBy: string;
  documentNumber: string;
  customerName: string;
  customerIdentity: number;
  customerNumber: string;
  description: string;
  elapsedHours: number;
  invoiceDocumentIdentity: number;
  invoiceNumber: string;
  invoiceStatus: string;
  isAttachmentExist: boolean;
  isCommentExist: boolean;
  isTimeOn: boolean;
  locationIdentity: number;
  locationName: string;
  woMeterDate: Date;
  meterType: string;
  meterValue: number;
  model: string;
  status: string;
  stockNumber: string;
  technicianIdentity: number;
  technicianName: string;
  salesPersonIdentity: number;
  salesPersonName: string;
  unitDescription: string;
  woDisplayText: string;
  woUnitIdentity: number;
  userName: string;
  warrantyDate: Date | null;
  woDeliveryDate: Date | null;
  woPickupDate: Date | null;

  /** WO status id from API (`workOrderStatusIdentity`); legacy mocks may use `WorkOrderStatusIdentity`. */
  workOrderStatusIdentity?: number;
  WorkOrderStatusIdentity?: number;
  purchaseOrderNumber: string;
  statusPosition: number;
  techPosition: number;
  priorityPosition?: number;
  positionChangeDate: Date;
  modifiedDate: Date;
  isCritical: boolean;
  woPriorityIdentity: number;
  woPriority: string;
  invoiceType: string | null;
  segments: Segment[];
  quotedHours: number; //It is FlatRateLabourHours within InvoiceSegment table
  profilePicture: string;
  nonPrintedComment: string;
  daysSinceLastClockIn: number;
  customerPhone: string;
  customerEmail: string;
  customerAddress: string;
  isWoHistoryExist: boolean;
  daysInCurrentstatus: number;

  scheduleStartTime: Date;
  scheduleEndTime: Date;
  totalInvoice?: number;
  rowVersion?: string;
  scheduleItemId?: number; // Indicates work order was created From Service Calendar V2
}

export interface WorkOrderHistory {
  activityType: string;
  changedBy: string;
  changedFields: string;
  createdDate: string;
  description: string;
  detailId: number;
  invoiceId: number;
  relatedEntity: string;
  segmentId: number;
  docNo: string;
  segmentName: string;
  commentId: number;
  itemType: string;
  displayText: string;
  relatedEntityName: string;
}
export interface Segment {
  identity: number;
  invoiceDocIdentity: number;
  lineNumber: number;
  itemIdentity: number;
  displayText: string;
  memo: string;
  billAs: string;
  flatRateLaborHours: number | string;
  actualOrFlatRateLaborHrs: number | string;
  shopSuppAmt: string;
  serviceCodeIdentity: number;
  status: string;
  standardJobSteps: string;
  stdJobCode: string;
  stdJobSource: string;
  clockedHours: number | string;
  hasAttachment: boolean;
  segmentDetails: WorkOrderSegmentDetail | null;
  rowVersion?: string;
}
////////////////////////////// Work Order Details
export interface WorkOrderSegmentDetail {
  name: string; //DisplayText
  memo: string;
  standardJobSteps: string;
  segmentIdentity: number;
  workOrderNumber: string;
  images: SegmentImages[] | null;
  attachments: SegmentAttachment[] | null;
  comments: SegmentComments[] | null;
  labor: SegmentLabor[] | null;
  checklists: SegmentChecklist[] | null;
  items: ItemDetails[] | null;
}
export interface SegmentImages {
  attachmentIdentity: number;
  segmentIdentity: number;
  imageIdentity;
}

export interface SegmentAttachment {
  attachmentIdentity: number;
  segmentIdentity: number;
  fileName: string;
  mime: string;
}
export interface SegmentLabor {
  identity: number;
  segmentIdentity: number;
  timeOn: Date | null;
  timeOff: Date | null;
  elapsedHours: number;
  technicianIdentity: number;
  technicianName: string;
  isClock: boolean;
  modifiedBy: string;
  modifiedDate: Date | null;
  enteredDate: Date | null;
  enteredBy: string;
  isActive: boolean;
  technicianComment: string;
  comment: string;
}
export interface SegmentComments {
  commentIdentity: number;
  segmentIdentity: number;
  technicianName: string;
  technicianIdentity: number;
  comment: string;
  commentActivity: string;
  modifiedBy: string;
  modifiedDate: string | null;
  enteredDate: string | null;
  enteredBy: string;
  commentIsActive: boolean;
  commentHistory: SegmentCommentHistory[] | null;
}
export interface SegmentChecklist {
  checklistIdentity: number;
  segmentIdentity: number;
  checklistName: string;
  checklistModifiedBy: string;
  checklistModifiedDate: string | null;
  checklistEnteredDate: string | null;
  checklistEnteredBy: string;
  checklistIsActive: boolean;
  checklistIsComplete: boolean;
  templateIdentity: number;
  attachmentIdentity: number | null;
}

export interface ItemDetails {
  segmentIdentity: number;
  itemIdentity: number;
  segmentItemType: string;
  segmentDisplayText: string;
  segmentDescription: string | null;
}
export interface SegmentCommentHistory {
  identity: number;
  commentIdentity: number;
  technicianName: string;
  technicianIdentity: number;
  comment: string;
  activity: string;
  modifiedBy: string;
  modifiedDate: string | null;
  createdDate: string | null;
  createdBy: string;
}

export interface WorkOrderCollection {
  orderByStatus: WorkOrdersByStatus[];
  orderByTechnician: WorkOrdersByTechnician[];
  orderByPriority?: WorkOrdersByPriority[];
}

export interface MeterType {
  key: string;
  value: string;
}

export interface StandardJobCodeType {
  key: string;
  value: string;
}

export const MeterTypeList: MeterType[] = [
  { key: "acres", value: "Acres" },
  { key: "bales", value: "Bales" },
  { key: "bushels", value: "Bushels" },
  { key: "hectare", value: "Hectares" },
  { key: "hours", value: "Hours" },
  { key: "kilometers", value: "Kilometers" },
  { key: "miles", value: "Miles" },
  { key: "seasonsusd", value: "Seasons Used" },
  { key: "sephours", value: "Separator Hours" },
];

export const StandardJobCodeTypeList: StandardJobCodeType[] = [
  { key: "description", value: "Job Description" },
  { key: "jobcode", value: "Job Code" },
  { key: "model", value: "Model" },
];

export const WorkOrderByStDefList: WorkOrdersByStatus[] = [];
export const WorkOrdersByTechDefList: WorkOrdersByTechnician[] = [];
export const WorkOrdersByPriorityDefList: WorkOrdersByPriority[] = [];
export const woStatusDefState: WorkOrderStatus[] = [];
export const techDefState: ApplicationUser[] = [];
export const salesPersonDefState: ApplicationUser[] = [];
export const locationsDefState: SettingsLocation[] = [];
export const woPriorityCodeDefState: WorkOrderPriorityCode[] = [];
export const serviceCodeDefState: ServiceCodes[] = [];
export const defWorkOrderState: WorkOrder = null;
export interface QueueFilter {
  statuses?: string;
  techIdentity?: number;
  customerIdentity?: number;
  locations?: string;
  date?: string;
}

export interface UpdateWorkOrder {
  invoiceDocumentIdentity: number;
  WorkOrderStatusIdentity?: number;
  workOrderStatusIdentity?: number;
  modifiedDate: string;
  rowVersion?: string;
}

export interface UpdateWorkOrderTech {
  invoiceDocumentIdentity: number;
  //position: number;
  technicianIdentity: number;
  modifiedDate: string;
  rowVersion?: string;
}

export interface UpdateWorkOrderPriority {
  invoiceDocumentIdentity: number;
  woPriorityIdentity: number;
  modifiedDate: string;
  rowVersion?: string;
}

// For Updating work order position/index in the database
export interface WorkOrderPositionItem {
  invoiceDocumentIdentity: number;
  position: number;
}

export interface UpdateStatusWisePosition {
  sourceItems?: WorkOrderPositionItem[] | null;
  destItems?: WorkOrderPositionItem[] | null;
  items?: WorkOrderPositionItem[] | null;
}

export interface Location {
  identity: number;
  displayText: string;
  CompanyName: string;
  GeneralLedgerNumber: number;
  emailAddress: string;
  taxGroupId: number | null;
  taxExemptId: number | null;
}

export interface WorkOrdersByStatus {
  identity: number;
  displayOrder: number;
  displayText: string;
  statusColor: string;
  textColor: string;
  elapsedHours: number | undefined;
  hoursClocked: number;
  workOrders: WorkOrder[];
}

export interface WorkOrdersByTechnician {
  identity: number;
  displayOrder: number;
  color: string;
  displayText: string;
  displayPicture: string;
  hoursQuoted: number;
  hoursClocked: number;
  workOrders: WorkOrder[];
}

export interface WorkOrdersByPriority {
  identity: number;
  displayOrder: number;
  displayText: string;
  statusColor: string;
  textColor: string;
  elapsedHours: number;
  hoursClocked: number;
  workOrders: WorkOrder[];
}

export interface ApplicationUser {
  identity: number;
  userName: string;
  isTechnician: boolean;
  defaultLocationIdentity: number;
}
export interface ServiceCodes {
  identity: number;
  serviceCode: string;
  description: string;
}
export interface StandardJobSource {
  source: string;
}
export interface Customer {
  identity: number;
  name: string;
  number: string;
  creditHold: boolean;
  customerPhone: string;
  customerEmail: string;
  customerAddress: string;
}

export interface Unit {
  identity: number;
  unitNumber: string;
  baseSerial: string;
  make: string;
  model: string;
  description: string;
  meterType: string;
  meterValue: number;
  warrantyDate: Date;
  stockstatus: string;
  tag: string;
  isAttachment: boolean;
  isNew: boolean;
  currentCustomerId?: number | null;
}
export interface StandardJobSearchResult {
  stdJobHeaderId: number | null;
  stdJobUnitModelId: number | null;
  source: string;
  jobCode: string;
  jobDescription: string;
  jobSteps: string;
  modelCode: string;
  modelDescription: string;
  durationHours: number;
  adjustmentPct: number;
  isModel: boolean;
  adjustmentDuration: number;
}

export interface StandardJobItem {
  code: string;
  description: string;
}
export interface ViewType {
  identity: number;
  displayText: string;
}
export const view = [
  { identity: 0, displayText: "By Status" },
  { identity: 1, displayText: "Assigned Technician" },
  { identity: 2, displayText: "Priority" },
];

export const billAsTypes = [
  { key: "actual", label: "Actual" },
  { key: "flatrate", label: "Flat Rate" },
];

export interface WorkOrderStatusOrder {
  statusIdentity: number;
  displayOrder: number;
  modifiedByUserIdentity: number;
  modifiedDate: string;
}

export interface workOrderTechnicianOrder {
  technicianIdentity: number;
  displayOrder: number;
  modifiedByUserIdentity: number;
  modifiedDate: string;
}

export interface WorkOrderPriorityOrder {
  priorityIdentity: number;
  displayOrder: number;
  modifiedByUserIdentity: number;
  modifiedDate: string;
}
